// extracted by mini-css-extract-plugin
export var redoItem = "_if-1";
export var redoTrigger = "_if-0";